import { mergeStyleSets, getTheme } from "@fluentui/react";

const theme = getTheme();

const styles = mergeStyleSets({
  container: {
    backgroundColor: theme.palette.themeLighterAlt,
    padding: "5px",
    borderRadius: "5px",
  },
  comboBox: {
    "& .ms-ComboBox::after": {
      border: `1px solid ${theme.palette.neutralLighter}`,
    },
  },
  comboBoxSearchBox: {
    margin: {
      root: {},
    },
    "ms-SearchBox": {
      overflow: "hidden",
    },
  },
  searchBox: {
    width: "100%",
    border: `1px solid ${theme.palette.neutralLighter}`,
    ":hover": {
      border: `1px solid ${theme.palette.themeLight}`,
    },
  },
  // DateRangeFilter styles
  dateFilterButtonContainer: {
    background: theme.palette.white,
  },
  dateFilterButton: {
    borderRadius: "2px",
    minWidth: 200,
    maxWidth: 300,
    background: theme.palette.white,
    height: "32px",
    color: theme.palette.neutralSecondary,
    justifyContent: "flex-start",
  },
  dateFilterButtonOperator: {
    borderRadius: "2px",
    minWidth: 200,
    maxWidth: 300,
    background: theme.palette.white,
    height: "32px",
    color: theme.palette.neutralSecondary,
    justifyContent: "flex-start",
  },
  dateFilterButtonText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  clearButton: {
    padding: 10,
  },
  calloutContent: {
    padding: 16,
  },
  filterTitle: {
    fontWeight: 600,
  },
  operatorDropdown: {
    minWidth: 150,
  },
});

export { styles };
